var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"create-booking-restriction-alert",attrs:{"text":"","prominent":"","type":"info"}},[_c('div',{attrs:{"id":"create-booking-restriction__message"}})])}
var staticRenderFns = []

export { render, staticRenderFns }